import { render, staticRenderFns } from "./RemoveFromJobButton.vue?vue&type=template&id=00b52021"
import script from "./RemoveFromJobButton.vue?vue&type=script&setup=true&lang=js"
export * from "./RemoveFromJobButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports